var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuddenSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3576_27583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26575 11.4999C1.26575 17.1516 5.84737 21.7333 11.4991 21.7333C17.1508 21.7333 21.7324 17.1516 21.7324 11.4999C21.7324 5.84822 17.1508 1.2666 11.4991 1.2666C5.84737 1.2666 1.26575 5.84822 1.26575 11.4999Z",
    fill: "#E4992C",
    stroke: "#2A2D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2588 11.8188C19.276 10.7701 19.0911 9.73177 18.7148 8.76293C18.3384 7.7941 17.7779 6.91384 17.0653 6.17234C16.3527 5.43083 15.5018 4.84264 14.5614 4.44134C13.621 4.04004 12.6095 3.8335 11.5845 3.8335C10.5595 3.8335 9.54123 4.04004 8.58765 4.44134C7.6341 4.84264 6.76402 5.43083 6.02709 6.17234C5.29015 6.91384 4.70079 7.7941 4.29267 8.76293C3.88454 9.73177 3.66563 10.7701 3.64844 11.8188H6.38025C6.39142 11.1371 6.53372 10.4622 6.799 9.83251C7.06428 9.20277 7.44737 8.63061 7.9264 8.1486C8.40541 7.66662 8.97091 7.28429 9.59076 7.02345C10.2105 6.76261 10.8725 6.62835 11.5387 6.62835C12.2049 6.62835 12.8625 6.76261 13.4737 7.02345C14.085 7.28429 14.638 7.66662 15.1012 8.1486C15.5644 8.63061 15.9287 9.20277 16.1734 9.83251C16.418 10.4622 16.5381 11.1371 16.527 11.8188H19.2588Z",
    fill: "url(#paint0_linear_3576_27583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4992 19.5502C15.9451 19.5502 19.5492 15.9461 19.5492 11.5002C19.5492 7.0543 15.9451 3.4502 11.4992 3.4502C7.05333 3.4502 3.44922 7.0543 3.44922 11.5002C3.44922 15.9461 7.05333 19.5502 11.4992 19.5502Z",
    stroke: "#2A2D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4304 9.06202L12.0002 12.3122",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8415 12.6122C12.8415 13.3532 12.2409 13.9538 11.4999 13.9538C10.7589 13.9538 10.1582 13.3532 10.1582 12.6122C10.1582 11.8712 10.7589 11.2705 11.4999 11.2705C12.2409 11.2705 12.8415 11.8712 12.8415 12.6122Z",
    fill: "white",
    stroke: "#2A2D34",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12H5H6",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4L11.5 4.5L11.5 5",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12H17",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3576_27583",
    x1: 3.45029,
    y1: 11.8835,
    x2: 19.546,
    y2: 11.6196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206731,
    stopColor: "#DEDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519231,
    stopColor: "#D62828"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3576_27583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuddenSpeed);
export default __webpack_public_path__ + "static/media/Icon_sudden_speed.01326c704affe87b14fd31cad8ae946d.svg";
export { ForwardRef as ReactComponent };